import gql from 'graphql-tag';
import { TICKET_LIST_DETAIL_FRAGMENT } from '../../../common/graphql/ticketList';

export const GET_SERVICE_RUN_WITH_TICKET_LIST = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			id
			serviceDockets {
				id
				date
				order
				machineServiceType
				machine {
					id
					assetId
					place {
						id
						name
					}

					location {
						id
						name
					}
				}
				ticketList {
					...ticketList
				}
			}
		}
	}
	${TICKET_LIST_DETAIL_FRAGMENT}
`;
